import config from 'config'
import useScript from 'react-script-hook'
import { useMemo } from 'react'

import { loadLendersRates } from 'common/utils/rates'

import useActiveLenders from './useActiveLenders'

const verticalNameMap = {
  refi: 'refi',
  in_school: 'inschool',
}

const useActiveLendersWithRates = ({ vertical, lenders = [], sortCallback }) => {
  const availableLenders = useActiveLenders(vertical)

  const filteredLenders = useMemo(() => {
    return lenders.length && availableLenders.length
      ? lenders.map((slug) => availableLenders.find((lender) => lender.slug === slug))
      : availableLenders
  }, [availableLenders, lenders])

  const [scriptLoading, scriptError] = useScript({
    src: config.ratesLibraryUrl,
    charset: 'utf-8',
    type: 'text/javascript',
  })

  const lendersWithRates = useMemo(() => {
    if (!scriptLoading && !scriptError) {
      return loadLendersRates({
        availableLenders: filteredLenders,
        filters: { vertical: verticalNameMap[vertical] },
        sortCallback,
      })
    }
    return []
  }, [scriptLoading, scriptError, filteredLenders, sortCallback])

  return lendersWithRates
}

export default useActiveLendersWithRates
